(() => {
  if (window.__psSiteInkRippleInstalled) return;
  window.__psSiteInkRippleInstalled = true;

  /*
   * The ripple is drawn inside its own clipping layer (.ps-ink-clip, overflow: hidden), so it can
   * never spill outside the tapped element (a ripple sticking out past the screen edge made Chrome
   * zoom the page in Arabic).
   *
   * The tapped element only gets the helper class (position: relative; overflow: hidden) while its
   * ripple is running. Before, the class stayed on every element that had ever been tapped, which
   * permanently clipped things like card shadows, dropdowns and badges sticking out of buttons.
   */

  const productCards = '.ps-variant-card-wrapper, .ps-available-variant-card, product-card, .product-card';
  const productImages = '.ps-available-variant-card__media, .card-gallery';
  const quickAddButtons = '.ps-variant-add, .quick-add__button, [ref="addToCartButton"], button[name="add"]';

  const genericInteractive = 'a, button, summary, [role="button"]';

  function findHost(target) {
    if (!(target instanceof Element)) return null;
    const quickAdd = target.closest(quickAddButtons);
    if (quickAdd) return quickAdd;
    const card = target.closest(productCards);
    if (card) return target.closest(productImages);

    return (
      target.closest('[data-filter-param-name*="availability"] .checkbox') ||
      target.closest('.quick-add__button, [ref="addToCartButton"], button[name="add"]') ||
      target.closest('a[href*="wa.me"], a[href*="whatsapp"], [class*="whatsapp" i], [id*="whatsapp" i]') ||
      target.closest('.facets-toggle__button') ||
      target.closest('#search-modal .resource-card') ||
      target.closest('.menu-drawer__menu-item') ||
      target.closest('.header-logo') ||
      target.closest('a.button, button.button') ||
      target.closest('product-card.product-card, .product-card') ||
      target.closest(genericInteractive)
    );
  }

  const releaseHost = (host) => {
    if (!host.querySelector(':scope > .ps-ink-clip')) host.classList.remove('ps-ink-host');
  };

  function drawRipple(event, host) {
    if (!host || host.hasAttribute('disabled') || host.getAttribute('aria-disabled') === 'true') return;

    host.querySelectorAll(':scope > .ps-ink-clip, :scope > .ps-site-ink-ripple').forEach((old) => old.remove());
    host.classList.add('ps-ink-host');

    const rect = host.getBoundingClientRect();
    if (!rect.width || !rect.height) {
      releaseHost(host);
      return;
    }

    const x = Math.min(Math.max(event.clientX - rect.left, 0), rect.width);
    const y = Math.min(Math.max(event.clientY - rect.top, 0), rect.height);
    const isProductCard = host.matches(productImages);
    const isQuickAdd = host.matches(quickAddButtons);

    let diameter;
    if (isProductCard) {
      diameter = Math.min(112, Math.max(84, rect.width * 0.42));
    } else {
      const radius = Math.max(
        Math.hypot(x, y),
        Math.hypot(rect.width - x, y),
        Math.hypot(x, rect.height - y),
        Math.hypot(rect.width - x, rect.height - y)
      );
      diameter = radius * 2;
    }

    const clip = document.createElement('span');
    clip.className = 'ps-ink-clip';
    clip.setAttribute('aria-hidden', 'true');

    const ink = document.createElement('span');
    ink.className = 'ps-site-ink-ripple';
    ink.style.width = diameter + 'px';
    ink.style.height = diameter + 'px';
    ink.style.left = x + 'px';
    ink.style.top = y + 'px';

    clip.appendChild(ink);
    host.appendChild(clip);

    const peakOpacity = isProductCard ? 0.30 : (isQuickAdd ? 0.38 : 0.50);
    const duration = isProductCard ? 320 : (isQuickAdd ? 80 : 430);
    const animation = ink.animate([
      { transform: 'translate(-50%, -50%) scale(0)', opacity: peakOpacity, offset: 0 },
      { transform: 'translate(-50%, -50%) scale(1)', opacity: peakOpacity, offset: 0.68 },
      { transform: 'translate(-50%, -50%) scale(1)', opacity: 0, offset: 1 }
    ], {
      duration,
      easing: 'cubic-bezier(.20,.68,.22,1)',
      fill: 'forwards'
    });

    const done = () => {
      clip.remove();
      releaseHost(host);
    };
    animation.finished.then(done, done);
  }

  document.addEventListener('pointerdown', event => {
    if (event.isPrimary === false || (event.button !== undefined && event.button !== 0)) return;
    const host = findHost(event.target);
    if (!host || host.matches(productImages)) return;
    drawRipple(event, host);
  }, { passive:true, capture:true });

  document.addEventListener('click', event => {
    const host = findHost(event.target);
    if (!host || !host.matches(productImages)) return;
    drawRipple(event, host);
  }, { passive:true, capture:true });
})();
